import { Component, inject, OnInit } from '@angular/core';
import moment from 'moment';
import { firstValueFrom } from 'rxjs';
import { LargeChartBar } from 'src/app/Interfaces/Admin/charts/LargeCharBar.interface';
import { LargeArea } from 'src/app/Interfaces/Admin/charts/LargeChartArea.interface';
import { SimpleChartBar } from 'src/app/Interfaces/Admin/charts/SimpleCharBar.interface';
import { ChartPie, DataPie } from 'src/app/Interfaces/Admin/charts/SimpleCharPie.interface';
import { Data_Visits } from 'src/app/Interfaces/Admin/reports/Data_Visits.interface';
import { Response_Admin } from 'src/app/Interfaces/Admin/Response_Admin.interface';
import { AdminService } from 'src/app/Services/Global/Admin/admin.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-system-visits-acdms',
    templateUrl: './system-visits-acdms.component.html',
    styleUrls: ['./system-visits-acdms.component.scss', '../../../../Styles/GlobalStyles.css'],
    standalone: false
})
export class SystemVisitsACDMSComponent implements OnInit {
  //+================== VARIABLES GENERAL ==================+\\
  public EndDate!: Date
  public StartDate!: Date

  //+================== VARIABLES DATA CHART ==================+\\
  public DataChartPieAdmin: ChartPie = { Title: 'Visitas por Año', percent: 75, Data: [], load: true }
  public DataChartBar: LargeChartBar = {
    Title: 'Visitas Generales',
    subtitle: '',
    DataX: [],
    DataY: [],
    total: 0,
    load: true
  }

  //+================== VARIABLES FOR COLOR SWETALERT ==================+\\
  private ColorConfirm: string = '#20a8e1';
  private ColorsCancel: string = '#fc6161';

  //+================== VARIABLES FOR TYPE FILES ==================+\\
  public Option_Type_Filter: any[] = [
    { Name: 'Día', Value: 1 },
    { Name: 'Semana', Value: 2 },
    { Name: 'Mes', Value: 3 },
    { Name: 'Año', Value: 4 }
  ];


  //+================== VARIABLES OPTIONS ==================+\\
  public Select_Option_Type_Filter = { Name: 'Mes', Value: 3 };

  //+================== VARIABLES FOR STATUS ==================+\\
  public Status_CCP = {
    Approved: 1,
    Pending: 2,
    Rejected: 3
  }

  public LoadPage: boolean = true;

  //-========================= SERVICES =========================-\\
  private Service_Admin = inject(AdminService);


  ngOnInit(): void {
    moment.locale('es')
    this.EndDate = new Date();
    this.Load_Visits();
  }

  //-================== FUNCTTION FOR LOAD SYSTEM VISITS ==================-\\
  private async Load_Visits(): Promise<void> {

    try {
      this.LoadPage = false;

      const resSystemVisits: Response_Admin = await firstValueFrom(this.Service_Admin.Get_SystemVisits({ Type: this.Select_Option_Type_Filter.Value, StartDate: this.StartDate ?? '', EndDate: this.EndDate }))

      if (resSystemVisits.success) {

        const { Data: dataVisits, total: totalVisits }: { Data: Data_Visits[]; total: number } = resSystemVisits.operation;

        this.StartDate = moment(dataVisits[0].DateD, 'DD/MM/YYYY').toDate() ?? ''


        const dataX: string[] = dataVisits.map((item: Data_Visits) => {
          const date = moment(item.DateD, 'DD/MM/YYYY').utc();

          switch (this.Select_Option_Type_Filter.Value) {
            case 1: return date.format('ll');
            case 2: return date.format('LL');
            case 3: return date.format('MMMM YY');
            default: return date.format('YYYY');
          }

        });

        const DataPieGeneral: DataPie[] = dataVisits.map((item: Data_Visits) => ({ value: item.DataD, name: moment(item.DateD, 'DD/MM/YYYY').format('YYYY') }))



        this.DataChartBar = {
          ...this.DataChartBar,
          DataX: dataX,
          DataY: dataVisits.map((item: Data_Visits) => item.DataD),
          total: totalVisits,
          subtitle: `Periodo: ${moment(this.StartDate).utc().format('DD/MM/YYYY')} - ${moment(this.EndDate).utc().format('DD/MM/YYYY')}`,
          load: true
        }

        this.DataChartPieAdmin = {
          ...this.DataChartPieAdmin,
          Data: DataPieGeneral
        }


      }

      this.LoadPage = true;

    } catch (e) {
      Swal.fire({
        title: 'Ocurrió un error (Visitas del sistema)',
        text: '¡Recargue la página, si el problema persiste notifique a supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      });

    } finally {
      this.LoadPage = true;
    }
  }


  public Reload_Page(): void {
    this.Load_Visits();
  }

}
